<ion-list lines="full">
  @for (item of items; track $index) {
    <ion-item button (click)="onItemClick(item)">
      <ion-label>
        <p>
          {{ item.name | translate }}
          @if (item.badgeText) {
            <ion-chip mode="ios" class="badge">{{
              item.badgeText | translate
            }}</ion-chip>
          }
        </p>
        <ion-text color="medium" class="sub">
          {{ item.description | translate }}
          @if (item.price) {
            <span>, &euro;{{ item.price }}</span>
          }
        </ion-text>
        @if (item.isRecurring) {
          @if (item.isExpired) {
            <ion-text color="danger" class="sub">
              {{ 'shop_expired' | translate }}
            </ion-text>
          } @else {
            @if (item.isCancelled) {
              <ion-text color="danger" class="sub">
                {{ 'shop_canceled' | translate }},
                {{ 'shop_validUntil' | translate }}:
                {{ item.validUntil | date: 'mediumDate' }}
              </ion-text>
            } @else {
              <ion-text color="medium" class="sub"
                >{{
                  (item.price ? 'shop_nextPayment' : 'shop_validUntil')
                    | translate
                }}: {{ item.validUntil | date: 'mediumDate' }}</ion-text
              >
            }
          }
        }
      </ion-label>
      @if (item.isRecurring && item.price) {
        <ion-icon name="repeat-outline" slot="end"></ion-icon>
      }
    </ion-item>
  }
</ion-list>
